import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { DocumentService } from '../services';
import {
  CancelAccessHistoryPage,
  ClearAccessHistoryError,
  LoadAccessHistoryPage,
  AccessHistoryActionTypes,
  RequestAccessHistoryPage,
  ThrowAccessHistoryError,
  ToggleAccessHistoryPageLoading,
} from '../actions';

@Injectable()
export class AccessHistoryEffects {
  showPageLoading = new ToggleAccessHistoryPageLoading({ pageLoading: true });
  hidePageLoading = new ToggleAccessHistoryPageLoading({ pageLoading: false });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private documentService: DocumentService,
  ) {}

  @Effect()
  loadAccessHistoryPage$ = this.actions$.pipe(
    ofType<RequestAccessHistoryPage>(AccessHistoryActionTypes.RequestAccessHistoryPage),
    map((action: RequestAccessHistoryPage) => action.payload),
    mergeMap(({ query }) => {
      this.store.dispatch(this.showPageLoading);
      const queryResult$ = this.documentService.getAccessHistoryPage(query);
      const observables = [queryResult$, of(query)];

      return forkJoin(observables).pipe(
        catchError((err) => of(err)),
        map((res) => {
          if (res.length) {
            this.store.dispatch(new ClearAccessHistoryError());
            this.store.dispatch(this.hidePageLoading);

            return new LoadAccessHistoryPage({
              accessHistories: res[0].data,
              totalCount: res[0].count,
              query: res[1],
            });
          }

          this.store.dispatch(new CancelAccessHistoryPage());

          return new ThrowAccessHistoryError({ error: res });
        }),
      );
    }),
  );
}
